import { CategoryQuery } from './category.query';
import { CategoryService } from './category.service';
import { CategoryStore } from './category.store';

export * from './category.model';
export * from './category.query';
export * from './category.service';
export * from './category.store';

// Export providers
export default [CategoryQuery, CategoryService, CategoryStore];